import { appRoute } from "routes/app/home.runtime"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { hasDemand } from "lib/authorization/has-demand"
import { isEnabled } from "lib/@components/feature"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { FentraPage } from "routes/qa/fentra/fentra-page"
import { FEATURE_FLAG_TESTING_TOOLS } from "routes/qa/feature-flag-testing-tools"
import { FEATURE_FLAG_MOCK_IDP } from "routes/qa/feature-flag-mock-idp"

// Native Fentra IdP management page — replaces the old iframe shell.
// The `$feature-` prefix makes these demands non-bypassable: unlike the plain
// `feature-` form, admins/superusers do NOT auto-pass them, so direct
// navigation is blocked unless both flags are actually enabled.
appRoute.register(
    "qa/fentra",
    // prettier-ignore
    <DemandGuard demands={["admin", `$feature-${FEATURE_FLAG_TESTING_TOOLS}`, `$feature-${FEATURE_FLAG_MOCK_IDP}`]} and>
        <FentraPage $lazy />
    </DemandGuard>
)

// Nav item — appears for admins only when both feature flags are enabled.
// `isEnabled` checks the real flag state (via `$feature-`), so the admin
// short-circuit cannot reveal the menu when the flags are off.
registerConditionalPageNavigation(
    () => hasDemand("admin") && isEnabled(FEATURE_FLAG_TESTING_TOOLS) && isEnabled(FEATURE_FLAG_MOCK_IDP),
    "/app/qa/fentra",
    "Fentra",
    "mdi:identifier",
    { group: "Testing Tools", priority: 10 }
)
